import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { enrichMediaPreviewLayersFromPayload } from '@/helpers/preview/enrich-media-preview-layers.helper';
import type { ControlDeviceDto } from '@/types/dtos/player/request/control-device.dto.ts';

// Here its actually irrelevant what response we get, we just pass it down to preview page of player.
// There it will get validated and used to show the preview
interface ControlPreviewResponse {
  playerSyncData: Record<string, unknown>;
}

export const useControlPreviewMutation = () => {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (body: ControlDeviceDto) => {
      const token = await getToken();
      return controlPreview(body, token ?? '');
    },
  });
};

const controlPreview = async (body: ControlDeviceDto, token: string): Promise<ControlPreviewResponse> => {
  const url = `${import.meta.env.VITE_API_URL}/player/control-preview`;
  const response = (await sendJSONRequest({ url, method: METHOD.POST, body, token })) as ControlPreviewResponse;
  return {
    playerSyncData: enrichMediaPreviewLayersFromPayload(response?.playerSyncData ?? {}),
  };
};
